<template>
    <div class="address">
        <Head
            :headInfo='headInfo'
            @onClickLeft='onBack'
            @onClickRight='onSubmit'
        />
        <div class="content">
            <van-field
                v-model="name"
                type="text"
                maxlength = '10'
                placeholder="收货人"
            />
            <van-field
                v-model="phone"
                type="text"
                maxlength = '11'
                placeholder="手机号码"
            />
            <van-field
                v-model="addressName"
                type="text"
                @click="onArea"
                :readonly = 'true'
                right-icon="question-o"
                placeholder="所在地区"
            />
            <van-field
                v-model="address"
                rows="3"
                autosize
                type="textarea"
                placeholder="详细地址   如街道、门牌号等"
            />
        </div>
        <div class="mtop20 setAddress">
            <van-cell center title="设为默认地址">
                <van-switch v-model="value2" @input="handleChange" slot="right-icon" size="24" />
            </van-cell>
        </div>
        <areaList ref="area" @onArea='onAreaData'></areaList>
    </div>
</template>
<script>
import areaList from '../common/area'
import { Toast } from 'vant'
import { mapActions } from 'vuex'
import Head from '../../common/head'
export default {
    name: 'addAddress',
    components: {
        areaList,
        Head
    },
    data () {
        return {
            headInfo: {
                title: '添加地址',
                rightText: '保存'
            },
            value2: false,
            confirmOrderBack: '',
            goodsId: '',
            type: 0,
            addressName: '', // 省市区名称
            address: '', // 详细地址
            name: '', // 收货人
            phone: '', // 电话
            memberCode: '', // 会员编码
            invoiceFlase: false,
            createBy: '', // 创建人
            areaData: '',
            isDefault: 0 // 默认地址
        }
    },
    watch: {
        'phone': {
            handler (newName, oldName) {
                if (newName.length > 11) {
                    this.phone = newName.substring(0, 11)
                } else {
                    this.phone = newName.replace(/\D/g, '')
                }
            }
        },
        'address': {
            handler (newName, oldName) {
                if (newName.length > 30) {
                    this.address = newName.substring(0, 30)
                }
            }
        }
    },
    methods: {
        ...mapActions(['saveAddressData']),
        onBack () {
            this.$router.back()
            // if (this.type == 2) {
            //     this.$router.replace({ path: this.confirmOrderBack, query: { id: this.goodsId } })
            // } else {
            //     this.$router.go(-1)
            // }
        },
        onArea () {
            this.$refs.area.onShow()
        },
        onAreaData (data) {
            this.addressName = data.addressName
            this.areaData = data
        },
        onSubmit () {
            if (!this.checkFrom()) {
                return false
            }
            this.saveAddress()
        },
        async saveAddress () {
            if (this.invoiceFlase) {
                return false
            }
            this.invoiceFlase = true
            try {
                await this.saveAddressData({
                    name: this.name,
                    phone: this.phone,
                    province: this.areaData.provinceName,
                    provinceId: this.areaData.provinceId,
                    city: this.areaData.cityName,
                    cityId: this.areaData.cityId,
                    area: this.areaData.countryName,
                    areaId: this.areaData.countryId,
                    address: this.address,
                    memberCode: this.memberCode,
                    createBy: this.createBy,
                    isDefault: this.isDefault
                }).then(() => {
                    Toast({
                        message: '添加成功!',
                        duration: 2000,
                        onClose: () => {
                            this.$router.back()
                            // this.$router.replace({ path: '/b2b/address/selectAddress', query: { activityShow: this.$route.query.activityShow, type: this.type } })
                            this.invoiceFlase = false
                        }
                    })
                })
            } catch (error) {
                this.invoiceFlase = false
            }
        },
        handleChange (event) {
            this.isDefault = this.value2 ? 1 : 0
        },
        checkFrom () {
            let phone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
            if (!this.name) {
                Toast('请输入姓名')
                this.invoiceFlase = false
                return false
            }
            if (!this.name.length > 10) {
                Toast('姓名最多可输入10个字')
                this.invoiceFlase = false
                return false
            }
            if (!this.phone) {
                Toast('请输入手机号码')
                this.invoiceFlase = false
                return false
            }
            if (!phone.test(this.phone)) {
                Toast('请输入11位手机号码')
                this.invoiceFlase = false
                return false
            }
            if (!this.addressName) {
                Toast('请选择所在地区')
                this.invoiceFlase = false
                return false
            }
            if (!this.address) {
                Toast('请输入详细地址')
                this.invoiceFlase = false
                return false
            }
            if (this.address.length > 30) {
                Toast('地址最多可输入30个字')
                this.invoiceFlase = false
                return false
            }
            return true
        }
    },
    async mounted () {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.memberCode = userInfo.companyCode
        this.createBy = userInfo.id
        this.confirmOrderBack = localStorage.getItem('confirmOrderBack')
        this.goodsId = localStorage.getItem('goodsId')
        this.type = this.$route.query.type
    }
}
</script>
<style lang="scss" scoped>
    .setAddress {
        padding-left: 32px;
        background: #ffffff;
    }
    .address {
        font-size: 32px;
        color: #000000;
        height: 100%;
        background: #f5f5f5;
        overflow: hidden;
        .content {
            padding-left: 32px;
            background: #ffffff;
        }
        .item{
            position: relative;
            padding: 32px;
            background: #ffffff;
            span{
                display: block;
                position: relative;
                overflow: hidden;
                input{
                    width: 100%;
                    border: none;
                    font-size: 32px;
                }
                textarea{
                    width: 100%;
                    border: none;
                    font-size: 32px;
                }
            }
        }
        .item2{
            padding: 24px 32px 22px;
            display: flex;
            justify-content: space-between;
            background: #ffffff;
        }
        .item3{
            padding: 32px;
            display: flex;
            justify-content: space-between;
            background: #ffffff;
        }
    }
    /deep/ .van-cell{
        padding-right: 32px;
    }
    /deep/ .van-cell__value{
        height: auto;
    }
    /deep/ .van-switch{
        border: 2px solid #e3e3e3;
    }
    /deep/ .van-icon-question-o:before{
        content: "\F00A";
    }
    /deep/ .van-switch__node{
        border: 2px solid #e3e3e3;
    }
</style>
